import React from "react";
import "./ProfilePic.css";
import photo from "../resource/photo1.jpg";

function ProfilePIc(props) {
  return (
    <div className="profileImage">
      <img
        src={photo}
        alt=""
        style={{
          objectFit: "cover",
          width: "100%",
          height: "100%",
          borderRadius: "15px",
        }}
      />
    </div>
  );
}
export default ProfilePIc;
